'use strict';

angular.module('pulianiBookStoreApp')
	.controller('ProductCtrl', function($scope, $state, product, productCategory, $stateParams, Global, Auth, MyCart, toaster, $uibModal, $timeout, Fullscreen, mywishlist,$rootScope) {
         $rootScope.title=$state.params.name;

		$scope.images = product.images;
		$scope.currencyType = Global.CURRENCY;

		$scope.jsonbody = {
			"limit": 12,
			"offset": 0,
			"category": [],
			"sortBy": {
				"attribute": "discount_price",
				"direction": "DESC"
			}
		};

		$scope.IMGslickConfig = {
			enabled: true,
			autoplay: false,
			draggable: true,
		};

		$scope.defaultQuantity = 1;

		$scope.isFullscreen = false;

		$scope.toggleFullScreen = function() {

			$scope.isFullscreen = !$scope.isFullscreen;
		}

		Auth.getCurrentUser(function(user) {
			if (user.email) {
				$scope.units_in_localStorage = 0;
			} else {
				var productCart = JSON.parse(localStorage.getItem('pulianiBookStoreApp.products'));
				if (productCart === null || productCart === undefined) {
					productCart = [];
				}
				for (var index = 0, length = productCart.length; index < length; index++) {
					if ($state.params.id == productCart[index].product_id) {
						$scope.units_in_localStorage = productCart[index].quantity;
					}
				}
				if (!$scope.units_in_localStorage) {
					$scope.units_in_localStorage = 0;
				}
			}
		});

		// Auth.getCurrentUser().then(function(data){
		// 	console.log("yahoo");
		// })

		// .catch(function(error){
		// 	console.log('fuck!');
		// })


		function regularBook() {
			$('#flipbook').css("background", "white");
			$('#flipbook').turn('size', 400, 300);

		}

		function zoomedInBook() {
			$('#flipbook').css("background", "black");
			$('#flipbook').turn('size', $(window).width() - ($(window).width() / 4), $(window).height() - ($(window).height() / 4));
		}


		Fullscreen.$on('FBFullscreen.change', function(evt, isFullscreenEnabled) {
			if (isFullscreenEnabled)
				zoomedInBook()
			else
				regularBook()
		});


		function getRelatedProducts() {
			productCategory.getProducts($scope.jsonbody).then(function(data) {
				$scope.RelBooks = data.data;
			});
		}
		
		function sortByKey(array, key) {
			return array.sort(function(a, b) {
				var x = a[key]; var y = b[key];
				return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			});
		}
        
		product.getProductDetail($stateParams.id).then(function(data) {

			data.data.images = sortByKey(data.data.images,'sort_order');
			console.log("data dtata images=======>>>>>>", data.data.images);
			$scope.productDetail = data.data;

			$timeout(function() {
				$('#flipbook').css("display", "block");
				$("#flipbook").turn({
					width: 400,
					height: 300,
					autoCenter: true
				});

			}, 0);


			//alert(JSON.stringify(data.data.category[0].id));
			$scope.jsonbody.category.push(data.data.category[0].id);
			getRelatedProducts();


			/*
			angular.forEach($scope.productDetail.images, function(value, key) {
			$scope.productDetail.images[key].thumb = value.url;
			$scope.productDetail.images[key].img = value.url;
			$scope.productDetail.images[key].description = '';
			}); 
			*/
			//alert(JSON.stringify($scope.productDetail));
		});


		$scope.onCartAdd = function(productid, quantity, unitsInStock) {

			// if((quantity > ($scope.productDetail.units_in_stock - $scope.units_in_localStorage)) || quantity < 1){

			// 	var message = "Specified quantity is not available!";

			// 	if($scope.productDetail.units_in_stock - $scope.units_in_localStorage < 1){
			// 		message = "Product is out of stock!";
			// 	}

			// 	toaster.pop("error",message);
			// 	return;
			// }
			//if(quantity > unitsInStock){

			// var message = "Specified quantity is not available!";

			// if($scope.productDetail.units_in_stock - $scope.units_in_localStorage < 1){
			// 	message = "Product is out of stock!";
			// }

			// toaster.pop("error",message);
			// return;

			// 	toaster.pop("quantity required");
			// }

			// if(!Auth.isLoggedIn){
			// 	$scope.units_in_localStorage = $scope.units_in_localStorage + quantity;	
			// }

			if (quantity <= 0) {
				toaster.pop("error", "Quantity should be more than zero");
				return;

			}else if(quantity > 0 && quantity < 101){
				MyCart.addToCart(productid, quantity, unitsInStock)

				.then(function(data) {
					flytocart(productid,$rootScope.isfromlanding);
					$scope.$emit('checkCartShell');
					//toaster.pop("info","Item added to cart");

				}, function(error) {
					toaster.pop("error", "Specified quantity is not available!");
				})
			}else if(quantity >= 101){
				toaster.pop("error", "Order Quantity more than 100 qualifies as a Bulk Order, please conatct customer support for bulk enquires");
			}

			
		}


		function flytocart(id,isfromlanding){

         var cartElem = angular.element(document.getElementsByClassName("shopping-cart"));
      //console.log("bounds",cartElem.offset());
      var offsetTopCart = cartElem.offset().top;
      var offsetLeftCart = cartElem.offset().left;
      var widthCart = cartElem.prop('offsetWidth');
      var heightCart = cartElem.prop('offsetHeight');
	  //console.log("offsetTopCart:"+offsetTopCart+";offsetLeftCart:"+offsetLeftCart+";widthCart:"+widthCart+";heightCart"+heightCart);
      //var imgElem = angular.element(event.target.parentNode.parentNode.parentNode.childNodes[3].childNodes[1].childNodes[2].childNodes[2].childNodes[1]);
      var imgElem = angular.element(document.getElementById("bookTplImg_"+id));
	  //console.log("ELEM",angular.element(event.target.parentNode.parentNode.parentNode.childNodes[3].childNodes[1].childNodes[2].childNodes[2].childNodes[1]));
      if(isfromlanding)
      {
       var posPar = angular.element(document.getElementById("parentElm_"+id));
      $('#flyingcontainer').css({ 'top': posPar.offset().top,'left':posPar.offset().left, width: '150px', height: '150px' });
      var parentElem = angular.element(document.getElementById("flyingcontainer"));
      }
      else
      var parentElem = angular.element(document.getElementById("parentElm_"+id));
		console.log("parentElem",parentElem);
      var offsetLeft = imgElem.prop("offsetLeft");
      var offsetTop = imgElem.prop("offsetTop");
      var imgSrc = imgElem.prop("currentSrc");
      console.log(offsetLeft + ' ' + offsetTop + ' ' + imgSrc);
	  console.log(imgElem.offset().top+' '+imgElem.offset().left);
      var imgClone = angular.element('<img src="' + imgSrc + '"/>');
      imgClone.css({
        'height': '150px',
        'position': 'absolute',
        'top': offsetTop + 'px',
        'left': offsetLeft + 'px',
        'opacity': 0.5,
		'overflow': 'visible',
		'zIndex': 9999
      });
      imgClone.addClass('itemaddedanimate');
	console.log("calcPix",offsetLeftCart-imgElem.offset().left);
      parentElem.append(imgClone);
      setTimeout(function () {
        imgClone.css({
			'height': '75px',
			'top': (offsetTopCart-imgElem.offset().top + heightCart/2)+'px',
			'left': (offsetLeftCart-imgElem.offset().left + widthCart/2)+'px',
			'opacity': 0.5, 
			'overflow': 'visible',
			'zIndex': 9999
        });
      }, 500);
      setTimeout(function () {
        imgClone.css({
          'height': 0,
          'opacity': 0.5,
		  'overflow': 'visible',
		  'zIndex': 9999
          
        });
        cartElem.addClass('shakeit');
      }, 2000);
      setTimeout(function () {
        cartElem.removeClass('shakeit');
        imgClone.remove();
		  
		if(isfromlanding)
		$('#flyingcontainer').css({ width: '1px', height: '1px' });
		  
      }, 2500);

		}


		//manage click event on images
		$scope.onThumbClick = function(Overkey) {

			$("#flipbook").turn("page", Overkey + 1);
		}


		//Get Extension of file from path
		function getExtension(filename) {

			var indexoflastDot = filename.lastIndexOf('.');
			return (indexoflastDot < 0) ? '' : filename.substr(indexoflastDot);
		}

		//Get path without extension
		function getPathWithoutExtension(filename) {

			var indexoflastDot = filename.lastIndexOf('.');
			return (indexoflastDot < 0) ? '' : filename.substr(0, indexoflastDot);
		}

		//Get thumbnail image from origional image pathoflastDot
		$scope.getThumbnailImage = function(image) {

			return getPathWithoutExtension(image) + '_thumb' + getExtension(image).toLowerCase();
		}


		$scope.onAddToWishList = function(productid) {

			mywishlist.AddToUserWishList({
				product_id: productid
			})

			.then(function(data) {

				toaster.pop("info", "Item added to wishlist");
			})

			.catch(function(error) {

				if (error && error.errorTitle === 'Login required') {
					$scope.$emit('openLoginModal');

				} else {

					toaster.pop("error", "Product is already added to wishlist!");
				}

				//toaster.pop("warning",error.errorTitle,error.errorDesc);
			});
		}


		//    $("#flipbook").bind("start", function(event, page, view) {
		//  		if (page.page==1 || page.page==$("#flipbook").turn("pages")) {
		//   			$("#clickhere").hide("slow");
		//  		}
		// });

		//    $("#flipbook").bind("first", function(event) {

		//   $("#clickhere").show("slow");
		// });

		//    $("#flipbook").bind("turned", function(event,page) {
		//   	   if(page==$("#flipbook").turn("pages") && (page%2==0))
		//       $("#clickhere").show("slow");
		// });



	});